import IconTrash from "./ADSProductDelete.svg";
import { useState } from "react";
import Icon from "../../../../../../../../../../../../Assets/Images/info-circle.svg";
import { useADSContext } from "../../../../../../../../context/ADSProvider";
import "./ADSProductDelete.scss";
import FailModal from "../../../../../../../../../../../../Components/FailModal";

const ADSProductDelete = ({ id }) => {
  const { deleteProduct, handleProductCreationSuccess } = useADSContext();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteProduct = async () => {
    try {
      await deleteProduct({ productId: id });
    } catch (e) {
      console.error(e);
    } finally {
      setShowDeleteModal(false);
      handleProductCreationSuccess({ withStatusCheck: false });
    }
  };

  const toggleDeleteModal = (e) => {
    e.stopPropagation();
    setShowDeleteModal((prev) => !prev);
  };

  return (
    <>
      <img
        src={IconTrash}
        alt="icon-trash"
        onClick={toggleDeleteModal}
        style={{ width: 18, height: 18 }}
      />

      <FailModal
        reverse
        show={showDeleteModal}
        title="Confirm Creation Deletion"
        description="Are you sure you want to delete this creation? All your prompts, and settings, will be permanently removed. This action is irreversible. Please confirm to proceed."
        onCancel={toggleDeleteModal}
        onRetry={handleDeleteProduct}
        retryText="Delete"
      />
    </>
  );
};

export default ADSProductDelete;
